import { render, staticRenderFns } from "./folders.vue?vue&type=template&id=1b646c40&scoped=true&"
import script from "./folders.vue?vue&type=script&lang=js&"
export * from "./folders.vue?vue&type=script&lang=js&"
import style0 from "./folders.vue?vue&type=style&index=0&id=1b646c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b646c40",
  null
  
)

export default component.exports